import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';
import AsyncSelect from 'components/AsyncSelect';
import {default as Modal, withModal} from 'components/Modal';
import {buildBookingOptions} from 'components/Fields/BookingSelectField';
import {BookingOption} from 'components/Fields/BookingSelectField/components';

import {fetchBookingOptionsForBookingSet as sdkFetchBookingOptionsForBookingSet} from 'sdk/bookingSets';

import {MODALS} from 'ducks/bookingSets';

import zoomIcon from 'assets/icons/zoom.svg';

import './styles.css';

class SelectBookingModal extends React.Component<any> {
  state = {
    selectedBooking: null
  };

  fetchBookingOptions = search => {
    const {data: {locationRef, bookingSetId}} = this.props;

    return sdkFetchBookingOptionsForBookingSet({
      locationRef,
      search,
      bookingSetId
    });
  };

  selectBookingOption = bookingOption => {
    this.setState({
      selectedBooking: _.get(bookingOption, 'object')
    });
  };

  clearBookingOption = () => {
    this.setState({selectedBooking: null});
  };

  openCreateItemModal = () => {
    this.props.openCreateItemModal({
      booking: this.state.selectedBooking,
      createItem: this.props.data.createItem
    });
  };

  render() {
    return (
      <Modal
        className="SelectBookingModal"
        show={true}
        type={Modal.SMALL}
        onClose={this.props.closeModal}>
        <Modal.Header heading={this.props.data.modalHeading} />
        <Modal.Body>
          <p className="SelectBookingModal__description">
            Select the booking you would like to add the invoice/ credit note/
            overpayment to:
          </p>
          <div className="SelectBookingModal__booking">
            <div className="SelectBookingModal__booking__label colab-bold">
              Select booking
            </div>
            <div
              className="SelectBookingModal__bookingWrapper"
              style={{backgroundImage: `url(${zoomIcon})`}}>
              <AsyncSelect
                fetchFunction={this.fetchBookingOptions}
                buildOptions={buildBookingOptions}
                optionRenderer={BookingOption}
                valueRenderer={BookingOption}
                arrowRenderer={null}
                creatable={false}
                filterOptions={false}
                placeholder={'Search by name or email'}
                onChange={this.selectBookingOption}
                onClear={this.clearBookingOption}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="SelectBookingModal__buttonContainer">
          <Button
            blue
            className="SelectBookingModal__selectButton"
            onClick={this.openCreateItemModal}
            disabled={_.isNil(this.state.selectedBooking)}>
            Select
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = () => ({});

const mapDispatchToProps = {};

export default withModal(
  MODALS.SELECT_BOOKING,
  mapStateToModalData,
  mapDispatchToProps
)(SelectBookingModal);
